import { getPractice } from 'library/auth';

export const hideAllergies = () => getPractice()?.data_provider === 'bahammas';

export const blueCheckboxCardClass = 'has-[:checked]:border-teamcare-blue has-[:checked]:bg-blue-50 has-[:checked]:text-teamcare-blue';

export const blueCheckboxClass = '[--chkbg:theme(colors.teamcare.blue)] checked:border-teamcare-blue';

export const choiceBtnSelected = 'bg-blue-50 border-teamcare-blue text-teamcare-blue hover:bg-blue-50 hover:border-teamcare-blue hover:text-teamcare-blue';

export const choiceBtnUnselected = 'bg-white border-gray-200 text-gray-800 hover:bg-white hover:border-gray-200 hover:text-gray-800';

// Shared look for every `unstyled` react-select in the profile flow. Spread and override per field.
export const selectClassNames = {
  control: () => 'input input-bordered flex w-full flex-nowrap items-center gap-2',
  valueContainer: () => 'min-w-0 !overflow-visible',
  singleValue: () => 'min-w-0 !overflow-visible',
  placeholder: () => 'text-gray-400',
  dropdownIndicator: () => 'shrink-0 text-gray-400',
  clearIndicator: () => 'shrink-0 text-gray-400 hover:text-gray-600',
  indicatorSeparator: () => 'hidden',
  menu: () => 'absolute z-20 mt-1 w-full overflow-hidden rounded-xl border border-base-300 bg-white shadow-lg',
  menuList: () => 'p-1.5 max-h-72 overflow-y-auto',
  noOptionsMessage: () => 'px-3 py-2 text-sm text-gray-400',
  option: ({ isSelected, isFocused }) =>
    `rounded-lg px-3 py-2 cursor-pointer ${isSelected ? 'bg-gray-100 font-medium' : isFocused ? 'bg-gray-50' : ''}`,
};
